<section
  class="ba-form-group ba-layout-tile"
  [attr.aria-label]="ariaLabel">
  <div class="ba-form-group-info">
    <h2 class="ba-heading">
      @if (count) {
        {{count < 10 ? 0 : ''}}{{count}}
      }
      <ng-content select="[panel-title]"></ng-content>
    </h2>
  </div>
  <div class="ba-form-group-fields">
    <ng-content></ng-content>
  </div>
</section>
